import InfoModal from "cartovistaExtend/mapTools/InfoModal";
import { Modal } from 'bootstrap';
import "../styles/infoModalExtend.css";

export default class InfoModalExtend extends InfoModal {
    constructor() {
        super(false);
        this._$layersNavTabs = $('<ul class="InfoModal-layers-navTabs nav nav-tabs" role="tablist"></ul>');
        this._$layersTabsContent = $('<div class="InfoModal-layers-tabsContent tab-content"></div>');
        this._$modal.find(".modal-body").html([this._$layersNavTabs, this._$layersTabsContent]);
    }

    _activated() {
        if (_.find(C.MAP_TOOLS.INFO_MODAL.LAYERS, {"LAYER_ID": this._map.selectionLayer.id}) && this._map.selectionLayer.selectionStack.length) {
            var featuresCollections = this._getFeaturesCollectionsFromSelection();
            this._showModal(featuresCollections);
        }
        InfoModal.prototype._activated.call(this);
    }

    _getFeaturesCollectionsFromSelection() {
        var featuresCollection = {"LAYER" : this._map.selectionLayer, "FEATURES" : []};
        this._map.selectionLayer.computeSelectionStack(function(linkingIds){
            this._map.selectionLayer.getFeatures(linkingIds, function(result) {
                _.forEach(result.features, function(feature) {
                    //keep only features that are not filteredOut and visible
                    if (!feature.filteredOut && feature.visible) {
                        if (typeof feature.featureCount == "undefined") {
                            featuresCollection.FEATURES.push(feature);
                        } else {
                            featuresCollection.FEATURES = _.concat(feature.features, [feature.centerFeature], featuresCollection.FEATURES);
                        }
                    }
                });
            });
        }.bind(this));

        return [featuresCollection];
    };

    _showModal(featuresCollections) {
      var modal = new Modal(this._$modal[0]);
      this._$modal[0].addEventListener('shown.bs.modal', function(){
        this._$layersNavTabs.html(_.map(featuresCollections, this._createLayerNavTab.bind(this)));
        this._$layersTabsContent.html(_.map(featuresCollections, this._createLayerTabContent.bind(this)));
      }.bind(this), {once : true});
      modal.show();
    };

    _createLayerNavTab(featuresCollection, idx) {
        var $tab = $('<li class="nav-item" role="presentation">' +
                    '<a class="nav-link' + (idx == 0 ? ' active' : '') + '" data-bs-target="#InfoModal-tab-' + featuresCollection.LAYER.id + '" aria-controls="InfoModal-tab-' + featuresCollection.LAYER.id + '" role="tab" data-bs-toggle="tab">' + featuresCollection.LAYER.name + "&nbsp;(" + featuresCollection.FEATURES.length + ")" + '</a>' +
                '</li>');
        return $tab;
    };

    _createLayerTabContent(featuresCollection, idx) {
        var $tabContent = $('<div role="tabpanel" class="tab-pane ' + (idx == 0 ? 'active' : '') + '" id="InfoModal-tab-' + featuresCollection.LAYER.id + '">' +
                                '<div class="InfoModal-accordion accordion" id="InfoModal-accordion-' + featuresCollection.LAYER.id + '"></div>' +
                            '</div>');
        if(idx == 0){
          $tabContent.find(".InfoModal-accordion").html(_.map(featuresCollection.FEATURES, this._createItemPanel.bind(this, featuresCollection.LAYER)));
        } else{
          this._$modal.find('.nav-link[data-bs-target="#InfoModal-tab-' + featuresCollection.LAYER.id + '"]')[0].addEventListener('shown.bs.tab', event => {
              $tabContent.find(".InfoModal-accordion").html(_.map(featuresCollection.FEATURES, this._createItemPanel.bind(this, featuresCollection.LAYER)));
          }, {once : true});
        }
        return $tabContent;
    };

    _createItemPanel(layer, feature, idx) {
        var infoTableConfig = _.find(C.MAP_TOOLS.INFO_MODAL.LAYERS, {"LAYER_ID": layer.id});
        var $itemPanel = $('<div class="accordion-item"></div>');
        this._getFeatureData(feature, layer, infoTableConfig.PANEL.HEADER.DATACOLUMNS).then(function(featureData){
            $itemPanel.html('<div id="InfoModal-accordion-heading-' + feature.id + '">' +
                                infoTableConfig.PANEL.HEADER.CONTENT_FN(feature, layer, featureData) +
                            '</div>' +
                            '<div id="InfoModal-panel-' + feature.id + '" class="InfoModal-collapse accordion-collapse collapse ' + (idx == 0 ? "show" : "") + '" data-bs-parent="#InfoModal-accordion-' + layer.id + '" aria-labelledby="InfoModal-accordion-heading-' + feature.id + '">' +
                                '<div class="accordion-body">' +
                                    '<div class="feature-data">'+
                                    '</div>' +
                                '</div>' +
                            '</div>');
            Promise.all(_.map(infoTableConfig.PANEL.SECTIONS, function(panelSectionConfig){
                return this._getFeatureData(feature, layer, panelSectionConfig.DATACOLUMNS);
            }.bind(this))).then(function(featureDatas){
                if (idx == 0) {
                    $itemPanel.find(".feature-data").html(_.map(featureDatas, function(featureData, i) {
                        return infoTableConfig.PANEL.SECTIONS[i].CONTENT_FN(feature, layer, featureData);
                    }.bind(this)));
                } else {
                  $itemPanel.find(".accordion-button").addClass("collapsed");
                  $itemPanel.find(".accordion-button").attr("aria-expanded", false);
                  $itemPanel.find("#InfoModal-panel-" + feature.id)[0].addEventListener("shown.bs.collapse", function() {
                      $itemPanel.find(".feature-data").html(_.map(featureDatas, function(featureData, i) {
                            return infoTableConfig.PANEL.SECTIONS[i].CONTENT_FN(feature, layer, featureData);
                        }.bind(this)));
                    }.bind(this), {once : true});
                }
            }.bind(this));
        }.bind(this));
        return $itemPanel;
    };

}
